import { GetServerSideProps } from 'next';

import { GetLocation } from '../templates/GetLocation';

export default function GetLocationPage() {
  return <GetLocation />;
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};
